export default __webpack_public_path__ + "static/media/quest_success.9f413727.mp3";